/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MoveToDetailsIconContainer from '../../NDC/component/MoveToDetailsIconContainer/MoveToDetailsIconContainer';
import LabelerDrugTable from '../../NDC/component/NDCByLabeler/LabelerDrugTable';
import LabelerTableComponent from '../../NDC/component/NDCByLabeler/LabelerTableComponent';
import {
  getAllLabelerList,
  getDrugListForLabeler,
} from '../../NDC/store/action';
import {
  checkURAAndAddToDetailsTable,
  dispatchErrorMessages,
  removeFromURADetailsTableData,
  setURADetailsTableData,
  setURALabelerDrugTableData,
  setURALabelerTableData,
  setURASearchLoading,
} from '../store/actions';
import URADetailsTable from './URADetailsTable';

const SearchByLabeler = ({
  fullScreen,
  setFullScreen,
  setError,
  validateForm,
  setClickedViewButton,
}) => {
  const dispatch = useDispatch();
  const [drugTableRow, setDrugTableRow] = useState([]);
  const [labelerRow, setLabelerRow] = useState(null);
  const [gridApi, setGridApi] = useState(null);

  const labelerDrugTableData = useSelector(
    (state) => state.sharedState.URASearchReducer.labelerDrugTableData
  );

  const labelerTableData = useSelector(
    (state) => state.sharedState.URASearchReducer.labelerTableData
  );

  const addSingleRowToDetailsTable = () => {
    if (drugTableRow.length === 0) {
      dispatch(dispatchErrorMessages(['Please select from the drug names.']));
    } else {
      dispatch(dispatchErrorMessages([]));
      dispatch(checkURAAndAddToDetailsTable(drugTableRow));
      gridApi.deselectAll();
    }
  };

  const addAllToDetailsTable = () => {
    if (labelerDrugTableData.length == 0) {
      dispatch(dispatchErrorMessages(['NDC not found.']));
    } else {
      dispatch(dispatchErrorMessages([]));
      dispatch(checkURAAndAddToDetailsTable(labelerDrugTableData));
      gridApi.deselectAll();
    }
  };
  const getLabelerData = async () => {
    dispatch(setURASearchLoading(true));
    const response = await getAllLabelerList();
    dispatch(setURASearchLoading(false));
    if (!response) {
      dispatch(dispatchErrorMessages(['Labeler Not Found.']));
    } else {
      dispatch(dispatchErrorMessages([]));
    }

    dispatch(setURALabelerTableData(response || []));
  };

  const callAndDataFromAPI = async () => {
    dispatch(setURASearchLoading(true));
    const result = await getDrugListForLabeler({
      labelerCode: labelerRow.labelerCode,
      page: 1,
      pageSize: 100,
    });
    dispatch(setURASearchLoading(false));

    dispatch(setURALabelerDrugTableData(result || []));
  };

  useEffect(() => {
    if (labelerRow) {
      callAndDataFromAPI();
    }
  }, [labelerRow]);

  useEffect(() => {
    getLabelerData();
  }, []);

  return (
    <>
      <div className="col-12">
        <LabelerTableComponent
          labelerTableData={labelerTableData}
          setLabelerRow={setLabelerRow}
          fullScreen={fullScreen}
          setFullScreen={setFullScreen}
        />
      </div>
      <div className="row mt-4 col-12">
        <div
          className="col-5 d-flex flex-column"
          style={{ padding: '36px 15px 0 15px' }}
        >
          <LabelerDrugTable
            labelerRow={labelerRow}
            labelerDrugTableData={labelerDrugTableData}
            setDrugTableRow={setDrugTableRow}
            gridApi={gridApi}
            setGridApi={setGridApi}
          />
        </div>
        <div className="col-2 px-2">
          <MoveToDetailsIconContainer
            handleSingleMove={() => addSingleRowToDetailsTable()}
            handleAllMove={() => addAllToDetailsTable()}
            handleAllRemove={() => {
              dispatch(setURADetailsTableData([]));
            }}
            handleSingleRemove={() => {
              dispatch(removeFromURADetailsTableData());
            }}
          />
        </div>
        <div className="col-5  d-flex flex-column">
          <URADetailsTable
            showFullScreen={false}
            setError={setError}
            validateForm={validateForm}
            setClickedViewButton={setClickedViewButton}
          />
        </div>
      </div>
    </>
  );
};

export default SearchByLabeler;
